import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ImpersonationBanner = () => {
  const { user, stopImpersonate } = useAuth();
  const navigate = useNavigate();
  if (!user?.impersonating) return null;

  const back = async () => {
    try {
      await stopImpersonate();
      toast.success("Returned to your admin account");
      navigate("/admin");
    } catch {
      toast.error("Failed to return to admin");
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[60] flex flex-wrap items-center justify-center gap-2 sm:gap-3 bg-amber-500 text-black text-xs sm:text-sm font-medium px-4 py-2 text-center"
    >
      <ShieldAlert className="w-4 h-4 shrink-0" />
      <span>
        Viewing as <strong>{user.name}</strong> ({user.role}) — admin impersonation
      </span>
      <button
        data-testid="stop-impersonation-btn"
        onClick={back}
        className="ml-1 rounded-full bg-black text-white px-3 py-1 text-xs font-semibold hover:opacity-90 transition-opacity"
      >
        Return to admin
      </button>
    </div>
  );
};
